module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="loading"></div>\r\n<div id="relationtypes-list-container">\r\n    <table class="table-striped table-hover table-condensed">\r\n        <head>\r\n            <thead>\r\n            <tr>\r\n                <th>Name</th>\r\n                <th>Description</th>\r\n                <th>Parent type</th>\r\n                <th>Child type</th>\r\n            </tr>\r\n            </thead>\r\n        </head>\r\n        <tbody id="relationtypes-list"></tbody>\r\n    </table>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/relationtypes/relationtypes-table.html
// module id = 434
// module chunks = 0